import { Button, Typography } from '@material-ui/core'
import classNames from 'classnames'
import * as React from 'react'
import ReactSVG from 'react-svg'

import ChildImage from '../../assets/img/child_icon.svg'
import StarsImage from '../../assets/img/stars.svg'

import { getLastWordFromString } from '../../services/utils'

import './style.scss'

interface IProps {
  title: string
  showStars?: boolean
  text: string | React.ReactNode
  showChild?: boolean
  buttonText: string
  buttonClick?: () => void
  textStyles?: React.CSSProperties
  className?: string
}

class PreviewTemplate extends React.Component<IProps> {
  render() {
    const {
      title,
      showStars,
      text,
      buttonText,
      buttonClick,
      showChild,
      textStyles,
      className
    } = this.props
    const { rest, last } = getLastWordFromString(title)
    return (
      <div className={classNames('template', 'mobile-container', className)}>
        <div className="top">
          {showStars && <ReactSVG src={StarsImage} className="image stars" />}
          <Typography className="title">
            {rest}{' '}
            <span className="last-word">
              {last}
              <i className="exclamation">!</i>
            </span>
          </Typography>
          <Typography className="text" style={textStyles}>
            {text}
          </Typography>
        </div>
        <div className="middle">
          {showChild && (
            <ReactSVG src={ChildImage} className="image child-icon" />
          )}
        </div>
        <div className="bottom">
          <Button onClick={buttonClick} className="submit-btn">
            {buttonText}
          </Button>
        </div>
      </div>
    )
  }
}

export default PreviewTemplate



// WEBPACK FOOTER //
// ./src/pages/PreviewTemplate/index.tsx